export const auditControl = {
  routes: [
    {
      path: "/audit-control/audit",
      component: () => import("../organization-audit-view"),
    },
    {
      path: "/audit-control/audit/detail/:id",
      component: () => import("../organization-audit-detail"),
      name: "organizationAuditDetail",
    },
    {
      path: "/audit-control/audit/detail/:id/control/:controlId",
      component: () => import("../organization-audit-control-detail"),
      name: "organizationAuditControlDetail",
    },
    {
      path: "/audit-control/audit/control/:id/detail",
      component: () => import("../organization-audit-control-detail"),
      name: "organizationAuditControlControlDetail",
    },
  ],
};
